import { Steps } from "antd";
import { Col, Row } from "react-bootstrap";
import { AiOutlineMail } from "react-icons/ai";
import { BsTwitterX } from "react-icons/bs";
import { FaLinkedinIn } from "react-icons/fa";
import { FiPhone } from "react-icons/fi";
import { MdOutlineMailOutline } from "react-icons/md";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { candidateStatusOption } from "../../help-service/enumList";
import { formatUTCDateTime } from "../../help-service/utils";
import img2 from "../../images/intelegain-white-logo.svg";
import { renderCandidateFeedbackStatus } from "../../utils/utils";
import "./candidatefeedback.scss";
import FooterSecondary from "../../common-component/footer-secondary/FooterSecondary";

const CandidateFeedback = () => {
  const params = useParams();
  const { singleCandidate, isSingleCandidateLoading } = useSelector(
    (state) => state.candidates
  );
  const { requisitionDetails } = useSelector((state) => state.requisition);
  const { data } = useSelector((state) => state.interviewRounds);
  const description = "This is a description.";

  const steps = data.map((item, index) => ({
    title: (
      <div className="d-flex align-items-center justify-content-between mt-2 text-nowrap">
        <h6 className="mb-0"> Round - {index + 1}</h6>{" "}
        <h6 className="mb-0">
          {formatUTCDateTime(item.itl_interviewdatetime)}
        </h6>{" "}
      </div>
    ),
    description: (
      <div
        className="d-flex align-items-center justify-content-between p-3 rounded-2 mt-3 mb-3"
        style={{ background: "#F4F5FC" }}
      >
        <h6 className="mb-0 text-black">{singleCandidate.lastname}</h6>
        {renderCandidateFeedbackStatus(item.itl_status)}
      </div>
    ),
    interviewStatus: item.itl_status,
  }));

  const dummyData = [
    {
      title: "Finished",
      description: "This is a description.",
    },
    {
      title: "In Progress",
      description: "This is a description.",
    },
    {
      title: "Waiting",
      description: "This is a description.",
    },
  ];

  return (
    <div className="candidate-feedback-container msq-custom-bg-light">
      <header className="msq-bg-dark-blue py-3">
        <div className="container">
          <img src={img2} />
        </div>
      </header>

      <section className="py-4 main-content-wrapper">
        <div className="container">
          <Row>
            <Col md={8}>
              <div className="d-flex flex-column h-100">
                <div className="bg-white p-4 rounded-2 mb-4">
                  <h4 className="mb-3">{singleCandidate.lastname}</h4>
                  <div className="d-flex align-items-center mb-2">
                    <FiPhone />
                    <span className="ms-2">
                      +91-{singleCandidate.itl_candidatecontact}
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <AiOutlineMail />
                    <span className="ms-2">{singleCandidate.itl_emailid}</span>
                  </div>
                </div>
                <div className="bg-white p-4 rounded-2 flex-grow-1 d-flex flex-column h-100 overflow-auto mb-4 mb-md-0">
                  <p>
                    Thank you for taking the time to attend the interview with
                    Intelegain for the position of{" "}
                    <span className="fw-semibold">
                      {requisitionDetails.itl_name}
                    </span>
                  </p>
                  <p>
                    Following is the status of your interview:{" "}
                    {renderCandidateFeedbackStatus(
                      singleCandidate.itl_candidatestatus
                    )}
                  </p>

                  <p>
                    {singleCandidate.itl_candidatestatus === 5 && (
                      <div className="fw-semibold">
                        Reason: <br />
                      </div>
                    )}
                    {
                      candidateStatusOption.emailstatusmessage[
                        singleCandidate.itl_candidatestatus
                      ]
                    }
                  </p>
                  <p>Kindly connect with HR in case of any concerns.</p>
                  <p>Thank you.</p>
                </div>
              </div>
            </Col>

            <Col md={4}>
              <div className="bg-white p-4 rounded-2 h-100 custom-stepper d-flex flex-column">
                <h5 className="mb-4">Interview Status</h5>
                <Steps
                  progressDot
                  direction="vertical"
                  current={steps.length}
                  items={steps.map((step, index) => ({
                    ...step,
                    className: `step-status-${
                      candidateStatusOption.stepperClass[step.interviewStatus]
                    }`,
                  }))}
                />
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <FooterSecondary />
    </div>
  );
};

export default CandidateFeedback;
